
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { SvoiIcon } from '@svoi-ui/components/icon'
import type { NewsCardModel } from '~/model/News'
import Utils from '~/utils'

export default defineComponent({
  name: 'ArticlesCard',
  components: { SvoiIcon },
  props: {
    card: {
      type: Object as PropType<NewsCardModel>,
      required: true
    }
  },
  computed: {
    formattedDate(): string {
      const dateString = this.card.created_at
      if (!dateString) return ''
      return Utils.parseDate(dateString as string)
    }
  }
})
